module.exports = __webpack_public_path__ + "img/beiyongshuiyuan.ecbc0a7c.png";